import React from 'react';
import { wrappable } from '@veupathdb/wdk-client/lib/Utils/ComponentUtils';

export default wrappable(function SiteHeader() {
  return (
    <div>
      <h1>EBRC Website</h1>
      <div>
        Create a <code>SiteHeader</code> wrapper to customize this header.
      </div>
    </div>
  );
});
